import { defineStore } from 'pinia'
import { ref, readonly } from 'vue'

export const useTrackingInteractionStore = defineStore('trackingInteractionStore', () => {
  // State
  const miniInteractionCount = ref(0)

  // Actions
  /**
   * Increments the counter for mini variant field changes.
   * This is used to limit the number of tracked interactions in the mini variant.
   */
  function incrementMiniInteractionCount() {
    miniInteractionCount.value++
  }

  /**
   * Resets the counter for mini variant field changes to zero.
   */
  function resetMiniInteractionCount() {
    miniInteractionCount.value = 0
  }

  return {
    // State
    miniInteractionCount: readonly(miniInteractionCount),

    // Actions
    incrementMiniInteractionCount,
    resetMiniInteractionCount
  }
})
